import React from "react";
import classNames from "classnames";
import ButtonBase from "@material-ui/core/ButtonBase";
import { withStyles } from "@material-ui/core/styles";
import reactGA from "../reactGA";
import PlayBadgeImg from "../images/google-play-badge.png";
import AppStoreBadgeImg from "../images/app-store-badge.svg";

const badgeStyles = () => ({
  button: {
    margin: 8
  },
  badgeImg: {
    height: 54
  }
});
let Badge = ({ classes, className, name, link, src, alt, style }) => (
  <ButtonBase
    className={classNames([classes.button, className])}
    focusRipple
    onClick={() => {
      reactGA.event({
        category: "User",
        action: `Clicked ${name} badge`
      });
      window.open(link, "_blank");
    }}
    style={style}
  >
    <img className={classes.badgeImg} src={src} alt={alt} />
  </ButtonBase>
);
Badge = withStyles(badgeStyles)(Badge);

const GooglePlayBadge = () => (
  <Badge
    link="https://play.google.com/store/apps/details?id=com.mondaybee.mondaybee"
    name="Android"
    src={PlayBadgeImg}
    alt="Get it on Google Play"
  />
);

const AppStoreBadge = () => (
  <Badge
    link="https://itunes.apple.com/us/app/mondaybee/id1460077604?mt=8"
    name="App Store"
    src={AppStoreBadgeImg}
    alt="Download on the App Store"
  />
);

export { Badge, GooglePlayBadge, AppStoreBadge };



// WEBPACK FOOTER //
// ./src/components/AppBadges.js